const mStatus = [
    "Select from the following...",
    "Single (never been married)",
    "Married",
    "Divorced/Widowed",
    "Separated"
]

export default mStatus